import script from "./AgentsTableStatusCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./AgentsTableStatusCell.vue?vue&type=script&setup=true&lang=ts"

import "./AgentsTableStatusCell.vue?vue&type=style&index=0&id=60af1b9b&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60af1b9b"]])

export default __exports__